import { endPoints } from 'src/config/urls'
import { APP_SCOPE } from 'src/store/localStorageKeys'
import Const from 'src/config/const'

let scope = localStorage.getItem(APP_SCOPE) || (process.env.APP_SCOPE && process.env.APP_SCOPE.toLowerCase()) || 'ibs'
let scopeCountry = (process.env.APP_COUNTRY || '').toLowerCase()
let isIbs = scope === 'ibs'
let isEvo = scope === 'evo'
let isOnePlan = process.env.APP_ONE_PLAN === 'true' && isEvo
let isEvoVietnam = isEvo && scopeCountry === Const.scopeCountryKeys.VIETNAM
let isEvoMalaysia = isEvo && scopeCountry === Const.scopeCountryKeys.MALAYSIA
let enableCbpPointsFeatureToggles = process.env.TOGGLES_MODULES_CBP_POINTS_USAGE
  ? process.env.TOGGLES_MODULES_CBP_POINTS_USAGE === 'true'
  : isEvo && !isEvoVietnam
let enableProductTaxRateFieldToggles = process.env.TOGGLES_MODULES_PRODUCTS_TAX_RATE_FIELD === 'true' || true

let config = {
  app: {
    scope,
    scopeCountry,
    isIbs,
    isEvo,
    isEvoMalaysia,
    isEvoVietnam,
    isOnePlan,
    menu: {
      icons: {
        itoken: isEvo ? require('assets/evo/icons/nav/itoken.svg') : require('assets/ibs/icons/nav/itoken.svg'),
        prp: require('assets/evo/icons/nav/prp2.svg'),
      },
    },
    images: {
      header: {
        logo: isOnePlan
          ? require(`assets/one-plan/logo-elken.png`)
          : isEvo
          ? require(`assets/evo/logo-evo.png`)
          : require(`assets/ibs/logo-ibs.png`),
        icons: {
          logout: 'fas fa-power-off fas fa-rotate-90',
        },
      },
      login: {
        particles: isOnePlan ? process.env.TOGGLES_PARTICLES === 'true' || false : true,
        bg: isEvo ? require(`assets/evo/login-evo-bg.png`) : require(`assets/ibs/login-ibs-bg.png`),
        logo: isOnePlan
          ? require(`assets/one-plan/logo-elken.png`)
          : isEvo
          ? require(`assets/evo/logo-evo.png`)
          : require(`assets/ibs/logo-ibs.png`),
      },
    },
    default: {
      info: {
        member: {
          show: isEvo
            ? [
                'cumulativePersonalSales1',
                'cumulativePersonalSales2',
                'memberRank',
                'councilRank',
                ...(enableCbpPointsFeatureToggles ? ['cumulativePersonalSales3'] : []),
              ]
            : [],
          hide: isEvo ? ['MembershipType', 'highestRank', 'effectiveRank'] : [],
        },
      },
      translations: {
        sales: {
          enrollment: {
            tab: {
              placement: 'common.words.placementOrSponsor',
            },
          },
        },
        member: {
          words: [
            {
              name: 'copyright',
              translationKey: 'common.words.copyright',
            },
          ],
        },
      },
      props: {
        layout: {
          header: {
            menuButton: isEvo ? [{ flat: true }, { size: 'lg' }] : [{ outline: true }],
          },
        },
      },
      classes: {
        layout: {
          header: {
            toolbar: isEvo ? ['no-padding'] : [],
            hamburgerIcon: isEvo ? [] : ['items-center'],
            logo: isOnePlan ? ['col-3'] : ['col-1'],
          },
        },
      },
    },
    modules: {
      auth: {
        login: {
          translations: {
            words: [
              {
                name: 'copyright',
                translationKey: 'common.words.copyright',
              },
            ],
          },
        },
      },
      product: {
        feature: {
          globalPurchaseLimit: scope === 'ibs',
        },
        default: {
          priceAttributes: {
            readOnly: [
              ...(isEvo ? ['base_bv', 'base_sv', 'base_cbp_point', 'stockist_base_bv', 'stockist_base_sv', 'sv'] : []),
              ...(!isEvoVietnam ? ['tax_rate'] : []),
            ],
            show: [
              ...(enableProductTaxRateFieldToggles ? ['tax_rate'] : []),
              ...(isEvo
                ? [
                    'bv',
                    'wp_bv',
                    'base_bv',
                    ...(isOnePlan ? ['cv_1', 'cv_2', 'cv_3', 'cv_4'] : []),
                    ...(!isOnePlan
                      ? [
                          'sv',
                          'wp_sv',
                          'base_sv',
                          'stockist_sv',
                          'stockist_base_sv',
                          'stockist_bv',
                          'stockist_base_bv',
                          'stockist_wp_fee',
                        ]
                      : []),
                    ...(enableCbpPointsFeatureToggles
                      ? ['wp_cbp_point', 'base_cbp_point', 'cbp_point', 'stockist_cbp_point']
                      : []),
                  ]
                : ['wp_cv', 'base_cv', 'cv_1', 'cv_2', 'cv_3', 'cv_4', 'cv_5', 'cv_6']),
            ],
          },
        },
        kitting: {
          table: {
            kittingProducts: {
              columns: {
                hide: isEvo
                  ? ['base_cv', 'wp_cv', ...(enableCbpPointsFeatureToggles ? [] : ['cbp_point'])]
                  : ['base_bv', 'sv', 'cbp_point', 'wp_bv'],
              },
            },
          },
          feature: {
            disableBaseAutoCalculation: !isOnePlan,
          },
        },
      },
      member: {
        fields: {
          readOnly: isEvo ? ['nationality'] : [],
          hide: isEvo
            ? [
                'enrolment_rank',
                'personalSales',
                'rankUpdateEnrollmentRank',
                'rankUpdateHighestRank',
                'highest_rank',
                ...(enableCbpPointsFeatureToggles ? [] : ['personalCBPPoint']),
                ...(isOnePlan ? [] : ['placement']),
              ]
            : ['personalSalesEvo', 'rankUpdateEffectiveRank', 'rankUpdateCouncilRank', 'personalCBPPoint'],
          show: isEvo
            ? [
                'car_fund_entitlement',
                'house_fund_entitlement',
                'has_withholding_tax',
                'council_rank',
                ...(isEvoVietnam
                  ? [
                      'distributor_agreement_number',
                      'ic_passport_place_of_issue',
                      'ic_passport_date_of_issue',
                      'work_permit_number',
                      'enrollment_contract_submission_branch',
                    ]
                  : [...(isOnePlan ? [] : 'gem_country')]),
              ]
            : ['has_withholding_tax'],
        },
        translations: {
          fields: [
            {
              name: 'effective_rank',
              translationKey: isEvo ? 'modules.members.fields.memberRank' : 'modules.members.fields.effectiveRank',
            },
            {
              name: 'highest_rank',
              translationKey: isEvo ? 'modules.members.fields.councilRank' : 'modules.members.fields.highestRank',
            },
          ],
        },
        setup: {
          hideMaritalDependency: isEvo,
        },
        sponsorTree: {
          element: {
            showDownlineTab: scope !== 'evo',
          },
          fields: {
            hide: ['treeType'],
          },
        },
        placementTreeDiagram: {
          memberSearchListParams: isEvo ? { exclude_non_active: true } : { exclude_non_active: false, active: -1 },
        },
        sponsorDownline: {
          translations: {
            words: [
              {
                name: 'councilRank',
                translationKey: isOnePlan
                  ? 'modules.members.memberSponsorDownlineListing.table.th.highestRank'
                  : 'modules.members.memberSponsorDownlineListing.table.th.councilRank',
              },
            ],
          },
        },
        downlineBvSv: {
          columns: {
            hide: isOnePlan ? ['highest_rank'] : ['council_rank', 'bv'],
          },
        },
      },
      sales: {
        default: {
          productListing: {
            table: {
              columns: {
                get: isEvo
                  ? [
                      { field: isAlternate => (isAlternate ? 'wp_bv' : 'bv'), label: 'common.terms.unitBV' },
                      ...(isOnePlan ? [{ field: 'cv_1', label: 'common.terms.unitAMP' }] : []),
                      ...(!isOnePlan ? [{ field: 'sv', label: 'common.terms.unitSV' }] : []),
                      ...(enableCbpPointsFeatureToggles ? [{ field: 'cbp_point', label: 'common.terms.unitCBP' }] : []),
                    ]
                  : [{ field: isAlternate => (isAlternate ? 'wp_cv' : 'base_cv'), label: 'common.terms.unitBV' }],
              },
            },
          },
          saleItems: {
            units: {
              table: {
                columns: {
                  get: isEvo
                    ? [
                        { field: 'unit_bv', label: 'common.terms.bv', decimal: 2 },
                        ...(isOnePlan ? [{ field: 'unit_amp', label: 'common.terms.amp' }] : []),
                        ...(!isOnePlan ? [{ field: 'unit_sv', label: 'common.terms.sv' }] : []),
                        ...(enableCbpPointsFeatureToggles
                          ? [{ field: 'unit_cbp_point', label: 'common.terms.cbp', decimal: 4 }]
                          : []),
                      ]
                    : [{ field: 'unit_cv', label: 'common.terms.bv', decimal: 2 }],
                },
              },
            },
          },
        },
        salesList: {
          fields: {
            show: isEvo ? [...(isEvoMalaysia ? ['oversea_top_up_order'] : [])] : [],
          },
        },
        listing: {
          table: {
            columns: isEvo
              ? [
                  ...(!isOnePlan ? [{ name: 'total_sv' }] : []),
                  ...(enableCbpPointsFeatureToggles ? [{ name: 'total_cbp_point' }] : []),
                ]
              : [],
          },
        },
        createUpdate: {
          info: {
            member: {
              show: isEvo
                ? ['cumulativePersonalSales2', ...(enableCbpPointsFeatureToggles ? ['cumulativePersonalSales3'] : [])]
                : [],
              hide: isEvo ? ['MembershipType'] : [],
            },
            cvs: {
              fields: {
                get: isEvo
                  ? [
                      { field: 'total_bv', label: 'common.terms.totalBV' },
                      ...(isOnePlan ? [{ field: 'total_amp_cv', label: 'common.terms.totalAMP' }] : []),
                      ...(!isOnePlan ? [{ field: 'total_sv', label: 'common.terms.totalSV' }] : []),
                      ...(enableCbpPointsFeatureToggles
                        ? [{ field: 'total_cbp_point', label: 'common.terms.totalCBP' }]
                        : []),
                    ]
                  : [
                      { field: 'total_cv', label: 'common.terms.totalBV' },
                      { field: 'total_amp_cv', label: 'common.terms.totalAMP' },
                    ],
              },
            },
          },
          element: {
            items: {
              transactionTypeTopSelectionButtons: !isOnePlan && isEvo,
              transactionType: isIbs || isOnePlan,
              overseaTopUpOrder: isEvoMalaysia,
            },
          },
        },
        salesCancellation: {
          default: {},
          element: {
            svTransferDocumentNumbers: isEvo,
          },
        },
        salesTransferArea: {
          fields: {
            show: isEvo ? [...(enableCbpPointsFeatureToggles ? ['total_cbp_point'] : [])] : [],
          },
        },
        salesSvTransferByProductList: {
          table: {
            productList: {
              columns: {
                hide: isEvo ? [...(enableCbpPointsFeatureToggles ? [] : ['total_cbp_point'])] : ['total_cbp_point'],
              },
            },
          },
        },
        salesSvTransferByProductArea: {
          fields: {
            show: isEvo ? [...(enableCbpPointsFeatureToggles ? ['total_cbp_point'] : [])] : [],
          },
          table: {
            availableProductList: {
              columns: {
                hide: isEvo
                  ? [...(enableCbpPointsFeatureToggles ? [] : ['total_cbp_point', 'transfer_cbp_point'])]
                  : ['total_cbp_point', 'transfer_cbp_point'],
              },
            },
          },
        },
      },
      enrollment: {
        tabs: {
          accountPreference: scope !== 'evo',
          translations: {
            words: [
              {
                name: 'placement',
                translationKey: 'common.words.placementOrSponsor',
              },
            ],
          },
        },
        feature: {
          normalEnrollment: {
            salesKit: isEvo && !isOnePlan,
          },
          expressEnrollment: isEvoVietnam,
        },
        element: {
          fields: {},
          blocks: {
            placement: scope === 'ibs' || isOnePlan,
          },
        },
        fields: {
          show: (isEvoVietnam && ['ic_passport_place_of_issue', 'ic_passport_date_of_issue']) || [],
        },
        info: {
          cvs: {
            fields: {
              get: isEvo
                ? [
                    { field: 'total_cv', label: 'common.terms.totalBV' },
                    ...(isOnePlan ? [{ field: 'total_wp_bv', label: 'common.terms.totalWP' }] : []),
                    ...(!isOnePlan ? [{ field: 'total_sv', label: 'common.terms.totalSV' }] : []),
                    ...(enableCbpPointsFeatureToggles
                      ? [{ field: 'total_cbp_point', label: 'common.terms.totalCBP' }]
                      : []),
                  ]
                : [
                    { field: 'total_cv', label: 'common.terms.totalBV' },
                    { field: 'total_wp_cv', label: 'common.terms.totalWP' },
                  ],
            },
          },
        },
      },
      bonus: {
        cwBonusIncomeStatement: {
          fields: {
            hide: isEvo ? [...(!isEvoMalaysia ? ['gem'] : [])] : ['reportType', 'gem'],
          },
        },
        memberBonusAdjustmentList: {
          table: {
            bonusAdjustmentList: {
              columns: {
                hide: isEvo ? [...(enableCbpPointsFeatureToggles ? [] : ['cbp_country'])] : ['cbp_country'],
              },
            },
          },
        },
        memberBonusAdjustmentArea: {
          fields: {
            show: isEvo ? [...(enableCbpPointsFeatureToggles ? ['cbp_country'] : [])] : [],
          },
        },
      },
      eSac: {
        voucher: {
          hide: isEvo ? [] : ['taxable_cw_id'],
        },
      },
      campaigns: {
        translations: {
          fields: [
            {
              name: 'eligible_for_bonus',
              translationKey: enableCbpPointsFeatureToggles
                ? 'modules.campaign.voucherType.fields.eligibleForBonusPoints'
                : 'modules.campaign.voucherType.fields.eligibleForBonusPointsWithoutCbp',
            },
          ],
        },
      },
    },
    general: {
      feature: {
        isIncomeTaxCountryFieldEnableBinding: isEvo && !isEvoVietnam && !isOnePlan,
      },
    },
    constant: {
      highestEnrollmentRank: process.env.CONST_HIGHEST_ENROLLMENT_RANK || 'PLATINUM',
    },
  },
  sidebar: {
    menu: {
      sorting: {
        modules: {
          dashboard: 0,
          products: 1,
          members: 2,
          sales: 3,
          autoship: 4,
          voucher: 5,
          bonus: 6,
          stockist: 7,
          procurements: 8,
          inventory: 9,
          ewallet: 10,
          itoken: 11,
          campaign: 12,
          receipt: 13,
          library: 14,
          reports: 15,
          settings: 16,
          prp: 11,
        },
      },
    },
  },
  toggles: {
    modules: {
      generalReceipt: process.env.TOGGLES_MODULES_GENERAL_RECEIPT === 'true' || true,
      settingsDepartment: process.env.TOGGLES_MODULES_SETTINGS_RECEIPT === 'true' || true,
      svMonthAmendment: isEvo,
      salesTransfer: isEvo,
      saleSvTransferByProduct: isEvo,
      productSetting: process.env.TOGGLES_MODULES_PRODUCT_SETTINGS
        ? process.env.TOGGLES_MODULES_PRODUCT_SETTINGS === 'true'
        : true,
      kittingPwpnValue: process.env.TOGGLES_MODULES_KITTING_PWPNVALUE === 'true' || false,
      pwpFocRangeType: process.env.TOGGLES_MODULES_PWP_RANGE_TYPE === 'true' || process.env.IS_DEVELOPMENT === 'true',
      salesCancellationBlock: process.env.TOGGLES_MODULES_SALE_CANCELLATION_BLOCK
        ? process.env.TOGGLES_MODULES_SALE_CANCELLATION_BLOCK === 'true'
        : true,
      cbpPoints: enableCbpPointsFeatureToggles,
    },
    notification: {
      oldDashboard: process.env.NOTIFICATION_OLD_DASHBOARD_INFO === 'true' || false,
    },
  },
  features: {
    enrollment: {},
  },
  pwa: {
    updateIntervalCheck: process.env.PWA_NEW_UPDATE_CHECK_INTERVAL || 50,
    autoUpdateTimer: process.env.PWA_AUTO_UPDATE_TIMER || 900,
  },
  plugins: {
    axios: {
      /**
         *
         * Endpoint rules for axios plugin
         *
         * {
          url: String, :: API Endpoint
          skipCancelRequest: Boolean :: will skip cancel request,
          cancelRequestWithParams: Boolean :: if true will include all params and store for comparison
          skipLoading: Boolean :: Skip from showing loading screen to users,
          skipAcl: Boolean, :: Skip Rules & permission
          skipServerValidation: Boolean :: Skipping from displaying server return validation messages (422)
          version: String :: Change backend API version default version `v1`
        }
         *
         * */
      endpointRules: [
        {
          url: endPoints.states,
          skipCancelRequest: true,
          skipLoading: true,
        },
        {
          url: endPoints.cities,
          skipCancelRequest: true,
        },
        {
          url: endPoints.countryRelation,
          skipCancelRequest: true,
        },
        {
          url: endPoints.mastersKey,
          cancelRequestWithParams: true,
        },
        {
          url: endPoints.logout,
          skipCancelRequest: true,
          skipLoading: true,
        },
        {
          url: endPoints.userDetails,
          skipCancelRequest: false,
          skipLoading: false,
          skipAcl: true,
        },
        {
          url: endPoints.countriesAll,
          skipCancelRequest: false,
          skipLoading: false,
          skipAcl: true,
        },
        {
          url: endPoints.login,
          skipCancelRequest: false,
          skipLoading: false,
          skipAcl: true,
        },
        {
          url: endPoints.refreshOauthToken,
          skipCancelRequest: true,
          skipLoading: false,
          skipAcl: true,
        },
        {
          url: endPoints.reset,
          skipCancelRequest: true,
          skipLoading: false,
          skipAcl: true,
        },
        {
          url: endPoints.resetPassword,
          skipCancelRequest: true,
          skipLoading: false,
          skipAcl: true,
        },
        {
          url: endPoints.getEnrollmentSalesTempData,
          skipCancelRequest: false,
          skipLoading: false,
          skipAcl: false,
          skipServerValidation: true,
        },
        {
          url: endPoints.fileUploadSetting,
          skipCancelRequest: true,
          skipLoading: false,
        },
        {
          url: endPoints.giroType,
          skipServerValidation: true,
        },
        {
          url: endPoints.languages,
          skipAcl: true,
        },
        {
          url: endPoints.downloadTemplate,
          version: 'v2',
        },
        {
          url: endPoints.uploadTemplate,
          version: 'v2',
        },
        {
          url: endPoints.processTemplate,
          version: 'v2',
        },
        {
          url: endPoints.verifyMobileNumber,
          skipServerValidation: true,
        },
        {
          url: endPoints.verifyEmail,
          skipServerValidation: true,
        },
        {
          url: endPoints.requestEmailValidation,
          skipServerValidation: true,
        },
        {
          url: endPoints.requestMobileNumberValidation,
          skipServerValidation: true,
        },
        {
          url: endPoints.taxInvoiceSearch,
          skipServerValidation: true,
        },
        {
          url: endPoints.kittingStatsById,
          skipServerValidation: true,
        },
        {
          url: endPoints.searchMember,
          skipLoading: true,
        },
        {
          url: endPoints.dashboard,
          cancelRequestWithParams: true,
        },
        {
          url: endPoints.config,
          skipServerValidation: true,
        },
        {
          url: endPoints.commissionWeek,
          skipServerValidation: true,
        },
        {
          url: endPoints.settings,
          skipServerValidation: true,
        },
        {
          url: endPoints.paymentsMethods,
          skipServerValidation: true,
        },
      ],
    },
  },
}
export default config
